import React, { useContext, useMemo } from "react";
import "./index.css";
import { MeioComunicacaoContext } from "../../../contexts/MeioComunicacaoContext";
import MidiaSocialIcone from "../../../components/MidiaSocialIcone";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";
import caAPI from "../../../services/caAPI";
import { BrowserView } from "react-device-detect";
import { usePromiseTracker } from "react-promise-tracker";

const carregamentoMeiosComunicacao =
  (
    <>
      {}
      <div className="meio-item meio-skeleton skeleton-animation"></div>
      <div className="meio-item meio-skeleton skeleton-animation"></div>
      <div className="meio-item meio-skeleton skeleton-animation"></div>
      <div className="meio-item meio-skeleton skeleton-animation"></div>
      <div className="meio-item meio-skeleton skeleton-animation"></div>
      <div className="meio-item meio-skeleton skeleton-animation"></div>
      <div className="meio-item meio-skeleton skeleton-animation"></div>
      <BrowserView>
        <div className="meio-item meio-skeleton skeleton-animation"></div>
      </BrowserView>
    </>
  )

export function MeioComunicacaoListaPrincipal(){
  const {meiosComunicacao} = useContext(MeioComunicacaoContext);
  const {promiseInProgress: isLoadingMeioComunicacao} = usePromiseTracker({area: "loading-meio-comunicacao"});
  const {meiosComunicacaoSelecionados, setMeiosComunicacaoSelecionados, handleExecutaPesquisaTelaPrincipal, setTipoAtendimentoSelecionado, setAtendimentoAtivo, buscandoAtendimentos} = useContext(AtendimentoContext);
  

  const handleClickMeio = (id)=>{
    if(buscandoAtendimentos){
      return;
    }
    var meios = meiosComunicacaoSelecionados;

    if(meios.includes(id)){
      meios = meios.filter((item) => Number(item) !== Number(id))
    }else{
      meios = [...meios, id]
    }
    setMeiosComunicacaoSelecionados(meios)
    const filtros = JSON.parse(caAPI.getLocalState('filtros'));
    filtros.meio_comunicacao = meios;
    handleExecutaPesquisaTelaPrincipal(filtros);
    setTipoAtendimentoSelecionado(null)
  }

  const meiosComunicacaoFiltrados= useMemo(()=>{
    return meiosComunicacao.filter((item) => item?.contatos_origem?.length)
  },[meiosComunicacao])

  return (
    <div className={`lista-meio-comunicacao-section ${buscandoAtendimentos ? "filtro-bloqueado" : ""}`}>
      {isLoadingMeioComunicacao ? 
        carregamentoMeiosComunicacao :
        meiosComunicacaoFiltrados.length ? meiosComunicacaoFiltrados.map((item, index)=>{
          return(
            <div 
              key={index}
              className={`meio-item ${!meiosComunicacaoSelecionados.length || meiosComunicacaoSelecionados.includes(item.id) ? "selecionado" : ""}`}
              onClick={()=>{handleClickMeio(item.id)}}
            >
              <MidiaSocialIcone
                midia={item?.slug || null}
              />
            </div>
          )
        }) : <></> 
      }
    </div>
  )
} 
